import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import Property from './Property.js';
import MultilineInput from '../MultilineInput/MultilineInput.js';

const _MultilineInput = styled(MultilineInput) `
  width: 100%;
  > div {
    width: 100%;
  }
`;
const MultilineInputProperty = (_a) => {
    var { className, label, maxRows = 2, inactive = true } = _a, rest = __rest(_a, ["className", "label", "maxRows", "inactive"]);
    return (jsx(Property, Object.assign({ label: label, className: className }, { children: jsx(_MultilineInput, Object.assign({ inactive: inactive }, rest, { multiline: true, maxRows: maxRows })) })));
};

export { MultilineInputProperty as default };
//# sourceMappingURL=MultilineInputProperty.js.map
